import React, { Fragment, Dispatch, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import Snackbar from '../../common/components/CreatedEnquirySnackbar';
import { Dialog, TableContainer, Table, TableBody, TableHead, TableCell, TableRow, InputLabel, InputAdornment, FormControl, OutlinedInput, Tooltip } from '@material-ui/core';
import TextField from "@material-ui/core/TextField";
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import SearchIcon from '@material-ui/icons/Search';
import clsx from 'clsx';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import WarningIcon from "@material-ui/icons/Warning";
import { saveReturnRequestAPI, getReturnSalesReasonAPI, createExcessReturnRequest } from "../../store/actions/delivery.actions";
import FullscreenLoader from './../../common/components/FullscreenLoader';
import { deletePartnerDocument, updateDocument } from '../../store/actions/editDealer.actions';
import CancelIcon from '@material-ui/icons/Cancel';
import DeleteIcon from '@material-ui/icons/Delete';
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import { get } from 'lodash';
import { searchProducts } from '../../store/actions/products.actions';

const useStyles = makeStyles((theme) => ({
  dialogContent: {
    padding: theme.spacing(2),
  },
  table: {
    width: '100%',
    tableLayout: 'fixed', // ⭐ THIS fixes half-width issue
  },
  fileName: {
    fontSize: '0.75rem',
    wordBreak: 'break-word',
    marginBottom: 4,
    color: '#1976d2',
  },
  noFile: {
    color: '#999',
    fontSize: '0.75rem',
  },
  icon: {
    float: "left",
    margin: "0 20px 35px 0",
    height: "100%",
    fill: "white",
  },
  yes: {
    fontSize: '0.813rem',
    fontFamily: 'Nunito',
    fontWeight: 700,
    color: '#1A9FE0',
    textTransform: 'capitalize'
  },
  cancel: {
    fontSize: '0.813rem',
    fontFamily: 'Nunito',
    fontWeight: 700,
    color: '#919191',
    textTransform: 'capitalize'
  },
  cancelText: {
    color: '#616161',
    fontSize: '0.875rem',
    fontFamily: 'Nunito',
    fontWeight: 700,
    textTransform: 'inherit',
  },
  dialogPaper: {
    borderRadius: 12,
    padding: 0,
  },
  root: {
    width: '100%',
  },
  addUpdateDailogTitle: {
    position: "absolute",
    top: 25,
    left: 5
  },
  addUpdateDailog: {
    top: 10,
    left: 4,
  },
  invoiceNumber: {
    fontSize: '0.913rem',
    fontFamily: 'Nunito',
    fontWeight: 800,
    color: '#2c2b2bff',
    marginLeft: 8,
  },
  // dialogContent: {
  //     padding: '24px 0px 36px 0px',
  // },
  tableHeader: {
    display: 'grid',
    gridTemplateColumns: '90px 110px 100px 130px 130px 180px 200px',
    gap: '12px',
    padding: '8px 0 6px 22px',
    borderBottom: '1px solid #d4e8f8ff',
    marginBottom: 6,
  },
  firsRowHeader: {
    color: '#133F8A',
    fontWeight: 900,
    fontSize: '0.75rem',
    borderBottom: 'none',
    paddingBottom: 0,
    textAlign: 'center'
  },
  SecondRowHeader: {
    padding: '0 0 10px 0',
    textAlign: 'center'
  },
  headerCell: {
    fontSize: '0.875rem',
    fontFamily: 'Nunito',
    fontWeight: 700,
    color: '#2196F3',
    lineHeight: 1.3,
  },
  tableRow: {
    display: 'grid',
    gridTemplateColumns: '90px 110px 100px 130px 130px 180px 200px',
    gap: '12px',
    padding: '8px 0 8px 22px',
    alignItems: 'start',
  },
  cellText: {
    fontSize: '0.813rem',
    fontFamily: 'Nunito',
    fontWeight: 400,
    color: '#333333',
  },
  inputField: {
    '& .MuiOutlinedInput-input::placeholder': {
      color: '#555555',
      opacity: 1,
      fontSize: '13px',
      fontFamily: 'Nunito',
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: 20,
      fontSize: '0.813rem',
      fontFamily: 'Nunito',
      backgroundColor: '#ffffff',
      height: 38
    },
    '& .MuiOutlinedInput-input': {
      padding: '8px 14px',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#CCCCCC',
    },
  },
  selectField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 20,
      fontSize: '0.813rem',
      fontFamily: 'Nunito',
      backgroundColor: '#ffffff',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#CCCCCC',
    },
  },
  browseButton: {
    backgroundColor: '#1DA1F2',
    color: '#ffffff',
    fontSize: '0.813rem',
    fontFamily: 'Nunito',
    fontWeight: 600,
    textTransform: 'none',
    padding: '8px 20px',
    borderRadius: 20,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#1a8cd8',
      boxShadow: 'none',
    },
    '&:disabled': {
      backgroundColor: '#CCCCCC',
      color: '#666666',
    },
  },
  fileInfo: {
    fontSize: '0.688rem',
    fontFamily: 'Nunito',
    color: '#666666',
    marginTop: 4,
    lineHeight: 1.4,
  },
  warningText: {
    fontSize: '0.75rem',
    fontFamily: 'Nunito',
    color: '#FF9800',
    fontWeight: 500,
    marginTop: 6,
  },
  mandatoryText: {
    fontSize: '0.75rem',
    fontFamily: 'Nunito',
    color: '#FF9800',
    fontWeight: 500,
    marginTop: 6,
  },
  dialogActions: {
    padding: '25px 36px 24px',
    justifyContent: 'flex-end',
    gap: 12,
    borderTop: '1px solid #e0e0e0',
  },
  proceedButton: {
    backgroundColor: '#1DA1F2',
    color: '#ffffff',
    fontSize: '0.875rem',
    fontFamily: 'Nunito',
    fontWeight: 700,
    textTransform: 'none',
    padding: '10px 40px',
    borderRadius: 24,
    minWidth: 140,
    '&:hover': {
      backgroundColor: '#1a8cd8',
    },
  },
  closeButton: {
    backgroundColor: '#E0E0E0',
    color: '#666666',
    fontSize: '0.875rem',
    fontFamily: 'Nunito',
    fontWeight: 700,
    textTransform: 'none',
    padding: '10px 40px',
    borderRadius: 24,
    minWidth: 140,
    '&:hover': {
      backgroundColor: '#D0D0D0',
    },
  },
  uploadDialog: {
    '& .MuiDialog-paper': {
      borderRadius: 12,
      maxWidth: 650,
      width: '100%',
    }
  },
  uploadTableHeader: {
    display: 'grid',
    gridTemplateColumns: '200px 200px 150px',
    gap: '16px',
    padding: '8px 0',
    borderBottom: '2px solid #d5dfe7ff',
    marginBottom: 12,
  },
  uploadTableRow: {
    display: 'grid',
    gridTemplateColumns: '200px 200px 150px',
    gap: '16px',
    padding: '8px 0',
    alignItems: 'center',
    borderBottom: '1px solid #e0e0e0',
  },
  uploadCellTitle: {
    fontSize: '0.813rem',
    fontFamily: 'Nunito',
    fontWeight: 400,
    color: '#333333',
  },
  uploadNote: {
    fontSize: '0.688rem',
    fontFamily: 'Nunito',
    color: '#999999',
    marginTop: 20,
    lineHeight: 1.4,
  },
  uploadActions: {
    padding: '12px 24px 16px',
    justifyContent: 'right',
    gap: 20,
    marginTop: "16px",
    marginBottom: "16px",
  },
  uploadButton: {
    backgroundColor: '#1DA1F2',
    color: '#ffffff',
    fontSize: '0.875rem',
    fontFamily: 'Nunito',
    fontWeight: 700,
    textTransform: 'none',
    padding: '10px 40px',
    borderRadius: 24,
    minWidth: 140,
    '&:hover': {
      backgroundColor: '#1a8cd8',
    },
  },
  cancelButton: {
    backgroundColor: '#E0E0E0',
    color: '#666666',
    fontSize: '0.875rem',
    fontFamily: 'Nunito',
    fontWeight: 700,
    textTransform: 'none',
    padding: '10px 40px',
    borderRadius: 24,
    minWidth: 140,
    '&:hover': {
      backgroundColor: '#D0D0D0',
    },
  },
  progressContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    width: '100%',
  },
  progressBar: {
    flex: 1,
    height: 4,
    backgroundColor: '#E0E0E0',
    borderRadius: 2,
    overflow: 'hidden',
    position: 'relative',
  },
  progressFill: {
    height: '100%',
    backgroundColor: '#1DA1F2',
    transition: 'width 0.3s ease',
  },
  fileInfoText: {
    fontSize: '0.688rem',
    fontFamily: 'Nunito',
    color: '#666666',
    marginLeft: 4,
  },
  title: {
    flex: '1 1 100%',
  },
}));


// Change the UploadedFile interface to not extend File
interface UploadedFile {
  id?: string;
  url?: string;
  documentStatus?: string;
  selectedFileName?: string;
  name?: string;
  size?: number;
  type?: string;
  lastModified?: number;
}
interface ReturnReason {
  code: string;
  message: string;
  sapMessage?: string;
  sapCode?: string;
  mandatory?: boolean;
}

export default function ReturnExcessPartPopup(props: any) {
  const classes = useStyles();
  const { handleopenClose, onReturnSuccess, existingReturnData, isUpdateMode, currentEtag } = props;
  const [fileIndexToDelete, setFileIndexToDelete] = React.useState<number | undefined>();
  const [returnQty, setReturnQty] = React.useState<any>('');
  const [selectedReason, setSelectedReason] = React.useState<string>('');
  const [showReasonWarning, setShowReasonWarning] = React.useState<boolean>(false);
  const [showReasonWarningIncase, setShowReasonWarningIncase] = React.useState<boolean>(false);
  const [showUploadDialog, setShowUploadDialog] = React.useState<boolean>(false);
  const [CloseButton, setCloseButton] = React.useState<boolean>(false);
  const [newlyUploadedFiles, setNewlyUploadedFiles] = React.useState<{ [key: string]: UploadedFile[] }>({});
  const [showConfirmDialog, setShowConfirmDialog] = React.useState<boolean>(false);
  const [uploadedFiles, setUploadedFiles] = React.useState<{ [key: string]: UploadedFile[] }>({});
  const [reasonError, setReasonError] = React.useState<boolean>(false);
  const [uploadError, setUploadError] = React.useState<boolean>(false);
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [uploadProgress, setUploadProgress] = React.useState<{ [key: string]: number }>({});
  const [successMessage, setSuccessMessage] = React.useState<any>(null);
  const [openErrorSnackbar, setOpenErrorSnackbar] = React.useState(false);
  const [loading, setLoading] = React.useState<any>(false);
  const [showErrorMessage, setShowErrorMessage] = React.useState<any>(null);
  const [returnQtyError, setReturnQtyError] = React.useState<string>('');
  const [selectedReturnItem, setSelectedReturnItem] = React.useState<any>(null);
  const { billingDetails }: any = useSelector((state: any) => state.delivery);
  const { profileDetails }: any = useSelector((state: any) => state.profileDetails);
  const webApplicationLoginId: any = sessionStorage.getItem("webApplicationLoginId");
  const customerName: any = sessionStorage.getItem("customerName");
  const [message, setMessage] = React.useState('');
  const dispatch: Dispatch<any> = useDispatch();
  // let sapCustomerId: any = _.get(profileDetails, "data.data.basicInfo.sapCustomerId", "");
  const billingData = billingDetails?.data?.data?.data;
  let sapCustomerId: any = billingData?.sapCustomerId || "";
  let etag: any = billingDetails?.data?.data?.data?._etag
  const [filesToDelete, setFilesToDelete] = React.useState<{ [key: string]: any }>({});
  const [documentIds, setDocumentIds] = React.useState<{ [key: string]: string }>({});
  const customerTierType = get(profileDetails, 'data.data.customerInfo.customerTierType', '');
  const { enquirySessionId }: any = useSelector(
    (state: any) => state.createUpdateEnquiry);
  const b2bUserId = get(profileDetails, 'data.data.basicInfo.b2bUserId', "");
  const firstName = get(profileDetails, 'data.data.basicInfo.firstName', "");
  const [showDeleteConfirmDialog, setShowDeleteConfirmDialog] = React.useState(false);
  const [isBulkDelete, setIsBulkDelete] = React.useState<boolean>(false);
  const [fieldToDelete, setFieldToDelete] = React.useState<string>('');
  const isFSE = sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre';
  const [rows, setRows] = React.useState([
    {
      partNo: '',
      description: '',
      returnQty: '',
      files: [] as File[],
    },
  ]);
  const [mandatoryUploadsComplete, setMandatoryUploadsComplete] = React.useState<boolean>(false);

  type UploadField = {
    title: string;
    required: boolean;
    tooltip?: string;
    minImages?: number;
  };

  // Formatted the customerTierType values
  const formatCustomerTier = (value: string | null) => {
    if (!value) return "";
    const trimmed = value.trim();
    const exactValues: Record<string, string> = {
      "tpc dealer": "tpcdealer",
      "tpcdealer": "tpcdealer",
      "int. business": "Int. Business",
      "int.business": "Int. Business",
      "tbl dealer": "TBL Dealer",
      "tbldealer": "TBL Dealer",
      "TBL Dealer": "TBL Dealer",
    };

    if (exactValues[value]) {
      return exactValues[value];
    }
    return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
  };

  const unformatCustomerTier =
    (sessionStorage.getItem('userType') === 'FSE' ||
      sessionStorage.getItem('userType') === 'sre')
      ? sessionStorage.getItem('customerTierType') ||
      get(profileDetails, 'data.data.customerInfo.customerTierType', '')
      : get(profileDetails, 'data.data.customerInfo.customerTierType', '');

  const updatedCustomerTierType = formatCustomerTier(unformatCustomerTier?.toLowerCase() || "");


  const handleAddRow = () => {
    setRows(prev => [
      ...prev,
      { partNo: '', description: '', returnQty: '', files: [] },
    ]);
  };

  const handlePartChange = (index: number, value: string) => {
    const updated = [...rows];
    if (value === '') {
      updated[index].description = ''
    }
    updated[index].partNo = value;
    setRows(updated);
  };

  const handleQtyChange = (index: number, value: string) => {
    const updated = [...rows];
    updated[index].returnQty = value;
    setRows(updated);
  };

  const handleFileUpload = (index: number, files: FileList) => {
    const updated = [...rows];
    const newFiles = Array.from(files).slice(0, 5); // max 5
    updated[index].files = newFiles;
    setRows(updated);
  };


  const handleDeleteRow = (index: number) => {
    const updated = [...rows];
    updated.splice(index, 1);
    setRows(updated);
  };

  const handleDeleteFile = (rowIndex: number, fileIndex: number) => {
    const updated = [...rows];
    updated[rowIndex].files.splice(fileIndex, 1);
    setRows(updated);
  };


  // Initialize with existing data if in update mode
  useEffect(() => {
    if (props.selectedItem) {
      setSelectedReturnItem({
        ...props.selectedItem,
        invoiceNumber: props.invoiceData?.data?.invoiceNumber || "",
      });


      if (!props.isUpdateMode) {
        setReturnQty('');
        setSelectedReason('');
        setUploadedFiles({});
        setUploadProgress({});
        setDocumentIds({});
        setShowReasonWarning(false);
        setShowReasonWarningIncase(false);
        setMessage('');
        return;
      }

      // ---------- UPDATE MODE ----------
      if (props.isUpdateMode && existingReturnData) {

        const files: UploadedFile[] = [];

        if (existingReturnData.returnImages) {
          Object.values(existingReturnData.returnImages).forEach((imgArr: any) => {
            if (Array.isArray(imgArr)) {
              imgArr.forEach((img) => {
                files.push({
                  id: img.id,
                  name: img.name,
                  url: img.url,
                });
              });
            }
          });
        }

        const updatedRows: any = [
          {
            partNo: existingReturnData.materialNumber || '',
            description: existingReturnData.description || '',
            returnQty: existingReturnData.returnQty?.toString() || '',
            files,
          },
        ];

        setRows(updatedRows);
        setSelectedReason(existingReturnData.returnReason || '');
        setMessage(existingReturnData.comment || '');
      }

    }
  }, [props.selectedItem, props.invoiceData, props.isUpdateMode, existingReturnData]);


  const getPrevDocId = (fieldTitle: string) => {
    return documentIds[fieldTitle] || '';
  };

  const handleBrowseFile = async (fieldTitle: string) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/png,image/jpeg,image/jpg';
    input.multiple = true;


    input.onclick = (e: any) => {
      const { target = {} } = e || {};
      target.value = "";
      setShowErrorMessage('');
      handleopenCloseErrorSnackbar(false);
    };

    input.onchange = async (e: any) => {
      const files = e.target.files;
      const file = files?.[0];

      if (!files || !files.length) return;

      const rowIndex = Number(fieldTitle.split('_').pop());
      const existingFiles = rows[rowIndex]?.files || [];

      if (existingFiles.length + files.length > 5) {
        setShowErrorMessage('Maximum 5 files allowed per row');
        handleopenCloseErrorSnackbar(true);
        return;
      }



      // Validate file type
      const name = file.name;
      const doctExtension = (name && name.substring(name.lastIndexOf('.') + 1, name.length)) || name;
      const doctExtensions = ['jpg', 'jpeg', 'png'];
      const canUploadFile = doctExtensions.indexOf(doctExtension.toLowerCase()) !== -1;

      if (!canUploadFile) {
        setShowErrorMessage('Invalid File type format. Please upload only jpg, jpeg or png images');
        handleopenCloseErrorSnackbar(true);
        return;
      }

      // Validate file size (5MB for return documents)
      const maxSize = 5 * 1024 * 1024; // 5MB
      if (file.size >= maxSize) {
        setShowErrorMessage('Please upload less than 5MB file');
        handleopenCloseErrorSnackbar(true);
        return;
      }

      // Show upload progress
      setUploadProgress(prev => ({ ...prev, [fieldTitle]: 0 }));

      // Prepare form data for API
      const formData: any = new FormData();
      const keyAttribute = `fieldname=${fieldTitle.replace(/\s+/g, "_")}&docExtension=${doctExtension}`;

      const customHeaders = {
        "Accept": "application/json",
        "Lob-Id": "AUTO",
        "Channel-Id": "B2B",
        "Org-Id": "",
        "Accept-Language": "EN",
      };

      formData.append("entityName", "CUSTOMER");
      formData.append("keyAttribute", keyAttribute);
      formData.append("fileUpload", file);
      formData.append("document", 'true');
      formData.append("Attributes", `key=ReturnReason&value=${selectedReason}`);
      formData.append("sapCustomerId", sapCustomerId ? sapCustomerId : '');
      formData.append("docType", fieldTitle);
      formData.append("label", fieldTitle.replace(/\s+/g, "_"));
      formData.append("b2bUserId", webApplicationLoginId ? webApplicationLoginId : '');
      formData.append("uploadedByRole", 'dealerUser');
      formData.append("uploadedBywebApplicationLoginId", webApplicationLoginId);
      formData.append("selectedFileName", file.name);
      formData.append("previousDocumentId", getPrevDocId(fieldTitle));
      formData.append("invoiceNumber", props.invoiceData?.data?.invoiceNumber || '');
      formData.append("materialNumber", selectedReturnItem?.materialNumber || '');

      setLoading(true);

      try {
        // Simulate progress
        let progress = 0;
        const interval = setInterval(() => {
          progress += 20;
          if (progress <= 80) {
            setUploadProgress(prev => ({ ...prev, [fieldTitle]: progress }));
          }
        }, 200);

        let uploadedDocumentData: any = await dispatch(updateDocument(formData, customHeaders));

        clearInterval(interval);

        // Check multiple possible success patterns
        let isSuccess = false;
        let errorMessage = '';

        if (uploadedDocumentData?.id && uploadedDocumentData?.url) {
          isSuccess = true;
        } else if (uploadedDocumentData?.data?.id && uploadedDocumentData?.data?.url) {
          uploadedDocumentData = uploadedDocumentData.data;
          isSuccess = true;
        } else if (uploadedDocumentData?.message?.status === 'S') {
          isSuccess = true;
        } else if (uploadedDocumentData?.messages?.some((msg: any) => msg.code === 'CREATE_SUCCESS')) {
          isSuccess = true;
        }

        if (isSuccess) {
          const {
            id,
            url,
            selectedFileName,
            originalname,
            fileName,
            label,
            documentStatus
          } = uploadedDocumentData;


          // Store document ID with both key formats
          setDocumentIds(prev => ({
            ...prev,
            [fieldTitle]: id,
          }));


          const displayName = selectedFileName || originalname || fileName || file.name;

          const fileObject: any = {
            id: id,
            url: url,
            documentStatus: documentStatus || 'UPLOADED',
            selectedFileName: displayName,
            name: displayName,
            size: file.size,
            type: file.type,
            lastModified: file.lastModified
          };
          const rowIndex = Number(fieldTitle.split('_').pop());

          setRows(prevRows => {
            const updatedRows = [...prevRows];

            updatedRows[rowIndex] = {
              ...updatedRows[rowIndex],
              files: [...(updatedRows[rowIndex].files || []), fileObject]

            };

            return updatedRows;
          });


          setUploadedFiles(prev => {

            const existingFiles = prev[fieldTitle] ?? []; // if undefined or null, default to []
            const updatedFieldFiles = [...existingFiles, fileObject];

            return {
              ...prev,
              [fieldTitle]: updatedFieldFiles,
            };
          });
          if (CloseButton) {
            setNewlyUploadedFiles(prev => {
              const existingFiles = prev[fieldTitle] || [];
              const updatedFieldFiles = [...existingFiles, fileObject];

              const updatedState = {
                ...prev,
                [fieldTitle]: updatedFieldFiles,
              };
              return updatedState;
            });
          }

          setUploadProgress(prev => ({ ...prev, [fieldTitle]: 100 }));

          setSuccessMessage('File uploaded successfully');
          setOpenSnackbar(true);
          handleopenCloseSnackbar(true);

          setLoading(false);
        } else {
          setLoading(false);

          errorMessage = uploadedDocumentData?.error ||
            uploadedDocumentData?.message?.message ||
            uploadedDocumentData?.messages?.[0]?.message ||
            'Document upload failed';

          setShowErrorMessage(errorMessage);
          handleopenCloseErrorSnackbar(true);

          setUploadProgress((prev: any) => {
            const newProgress = { ...prev };
            delete newProgress[fieldTitle];
            return newProgress;
          });
        }
      } catch (error) {
        setLoading(false);
        setShowErrorMessage('Document upload failed: ' + ((error as any)?.message || 'Unknown error'));
        handleopenCloseErrorSnackbar(true);

        setUploadProgress(prev => {
          const newProgress = { ...prev };
          delete newProgress[fieldTitle];
          return newProgress;
        });
      }
    };

    input.click();
  };


  const removeFileFromState = (fieldTitle: string, fileId?: string) => {
    const underscoreKey = fieldTitle.replace(/\s+/g, '_');
    const spaceKey = fieldTitle.replace(/_/g, ' ');
    const keys = Array.from(new Set([fieldTitle, underscoreKey, spaceKey]));

    const cleanState = (state: { [key: string]: UploadedFile[] }, removeFileId?: string) => {
      const newState: { [key: string]: UploadedFile[] } = { ...state };

      keys.forEach(key => {
        if (!newState[key]) return;

        if (removeFileId) {
          const filtered = newState[key].filter(f => f.id !== removeFileId);
          if (filtered.length > 0) {
            newState[key] = filtered;
          } else {
            delete newState[key];
          }
        } else {
          delete newState[key];
        }
      });

      return newState;
    };

    setUploadedFiles(prev => cleanState(prev, fileId));
    setNewlyUploadedFiles(prev => cleanState(prev, fileId));

    setUploadProgress(prev => {
      const newProgress = { ...prev };
      keys.forEach(key => delete newProgress[key]);
      return newProgress;
    });

    setDocumentIds(prev => {
      const newIds = { ...prev };
      keys.forEach(key => delete newIds[key]);
      return newIds;
    });
  };

  const removeFileFromRow = (fieldTitle: string, index?: number) => {
    const rowIndex = Number(fieldTitle.split('_').pop());

    setRows(prevRows => {
      const updatedRows = [...prevRows];

      if (updatedRows[rowIndex]) {
        updatedRows[rowIndex] = {
          ...updatedRows[rowIndex],
          files: updatedRows[rowIndex].files.filter((_, i) => i !== index)
        };
      }

      return updatedRows;
    });
  };



  const handleRemoveFile = (fieldTitle: string, index?: number) => {
    const rowIndex = Number(fieldTitle.split('_').pop());
    const fileData: any = rows[rowIndex]?.files?.[index ?? 0];

    if (!fileData) return;

    // If file has backend ID → confirm delete
    if (fileData.id) {
      setFilesToDelete({ [fieldTitle]: fileData });
      setFieldToDelete(fieldTitle);
      setFileIndexToDelete(index);
      setShowDeleteConfirmDialog(true);
    }
  };

  const deleteDocument = async () => {
    const obj = { type: 'RETURN_SALES' };
    setLoading(true);

    try {
      if (isBulkDelete) {
        const hasNewlyUploaded = newlyUploadedFiles && Object.keys(newlyUploadedFiles).length > 0;
        const filesToProcess = hasNewlyUploaded ? newlyUploadedFiles : uploadedFiles;

        for (const [fieldTitle, fileDataArray] of Object.entries(filesToProcess)) {
          const filesArray = Array.isArray(fileDataArray) ? fileDataArray : [fileDataArray];

          for (let index = 0; index < filesArray.length; index++) {
            const fileData = filesArray[index];

            if (!fileData?.id) continue;

            // Skip only if newlyUploadedFiles exists and file is not in it
            if (hasNewlyUploaded) {
              const isNewlyUploaded = newlyUploadedFiles[fieldTitle]?.some(f => f.id === fileData.id);
              if (!isNewlyUploaded) continue;
            }

            const res: any = await dispatch(
              deletePartnerDocument(
                webApplicationLoginId,
                fileData.id,
                obj,
                sapCustomerId
              )
            );

            if (res?.message) {
              removeFileFromState(fieldTitle, fileData.id);
            }
          }
        }

        // Clean up newlyUploadedFiles state
        setNewlyUploadedFiles(prev => {
          const updated = { ...prev };
          Object.keys(updated).forEach(field => {
            if (!updated[field]?.length) delete updated[field];
          });
          return updated;
        });

        setOpenSnackbar(true);
        setSuccessMessage('Documents deleted successfully');
        setShowUploadDialog(false);
      }
      else {
        const fileData = filesToDelete[fieldToDelete];

        if (!fileData) return;

        // If no ID → local file only
        if (!fileData.id) {
          removeFileFromState(fieldToDelete, fileData?.id);
          setFileIndexToDelete(undefined);
          return;
        }

        const deleteDocumentData: any = await dispatch(
          deletePartnerDocument(
            '',
            fileData.id,
            obj,
            sapCustomerId
          )
        );

        if (deleteDocumentData?.message) {
          removeFileFromState(fieldToDelete, fileData.id);
          removeFileFromRow(fieldToDelete, fileIndexToDelete);

          setFileIndexToDelete(undefined);
          setOpenSnackbar(true);
          setSuccessMessage('Document deleted successfully');
        } else {
          setShowErrorMessage('Failed to delete document');
          handleopenCloseErrorSnackbar(true);
        }
      }

    } catch (error) {
      setShowErrorMessage('Failed to delete document');
      handleopenCloseErrorSnackbar(true);
    } finally {
      setLoading(false);
      setFieldToDelete('');
      setFilesToDelete({});
      setIsBulkDelete(false);
    }
  };

  const handleopenCloseSnackbar = (open?: any) => {
    setOpenSnackbar(open ? true : false);
  };

  const handleopenCloseErrorSnackbar = (open?: any) => {
    setOpenErrorSnackbar(open ? true : false);
  };

  const saveReturnRequest = async (data: any) => {
    setLoading(true);
    const sessionDetails = {
      webApplicationLoginId: webApplicationLoginId,
      clientIPAddress: sessionStorage.getItem('clientIp'),
    };
    let userRole: any = sessionStorage.getItem('userType-Profile-API');

    let excessPart: any = data?.excessParts?.length > 0 ? data?.excessParts[0] : {}

    const payload = {
      id: billingDetails?.data?.data?.data?.id,
      itemDetails: [
        {
          materialNumber: excessPart?.materialNumber,
          returnQty: Number(excessPart?.returnQty),
          reason: selectedReason,
          itemId: selectedReturnItem?.itemId,
          returnImages: excessPart.returnImages
        }
      ],
      createdBy: isFSE ? billingDetails?.data?.data?.data?.customerName : customerName,
      sapCustomerId: isFSE ? billingDetails?.data?.data?.data?.sapCustomerId : sapCustomerId,
      sessionDetails,
      customerTierType: updatedCustomerTierType,
      role: userRole,
      etag: currentEtag || billingDetails?.data?.data?.data?._etag
    };

    try {
      const responseData: any = await dispatch(saveReturnRequestAPI(payload));

      if (responseData && responseData.status === 400) {
        setOpenErrorSnackbar(true);
        handleopenCloseErrorSnackbar(true);
        setShowErrorMessage(responseData?.error || 'Failed to save return request');
      } else {
        setOpenErrorSnackbar(false);
        handleopenCloseErrorSnackbar(false);
        setShowErrorMessage(null);
        handleopenCloseSnackbar(true);
        setSuccessMessage(responseData?.message?.message || 'Return request saved successfully');

        // Extract new etag from response
        const newEtag: any = responseData?.data?.data?._etag;
        handleConfirmYes(newEtag);
      }
    } catch (error) {
      setShowErrorMessage('Failed to save return request: ' + (error as any)?.message || 'Unknown error');
      handleopenCloseErrorSnackbar(true);
    } finally {
      setLoading(false);
    }
  };

  const handleProceed = async () => {
    for (let i = 0; i < rows.length; i++) {
      const row = rows[i];
      const rowIndex = i + 1; // for user-friendly messages
      const invoiceParts =
        billingDetails?.data?.data?.data?.itemDetails?.map((item: any) =>
          String(item.materialNumber).trim().toUpperCase()
        ) || [];



      // Part No mandatory
      if (!row.partNo || row.partNo.trim() === '') {
        setOpenErrorSnackbar(true);
        handleopenCloseErrorSnackbar(true);
        setShowErrorMessage(`Please enter Part No. in row ${rowIndex}.`);
        return;
      }
      const enteredPart = String(row.partNo).trim().toUpperCase();

      if (!invoiceParts.includes(enteredPart)) {
        handleopenCloseErrorSnackbar(true);
        setShowErrorMessage(`Part No. ${row.partNo} is not available in Invoice (row ${rowIndex}).`);
        return;
      }


      // Description mandatory
      if (!row.description || row.description.trim() === '') {
        setOpenErrorSnackbar(true);
        handleopenCloseErrorSnackbar(true);
        setShowErrorMessage(
          `Description not available for Part No. ${row.partNo} (row ${rowIndex}).`
        );
        return;
      }

      // Return Qty mandatory
      if (
        row.returnQty === '' ||
        row.returnQty === null ||
        row.returnQty === undefined
      ) {
        setOpenErrorSnackbar(true);
        handleopenCloseErrorSnackbar(true);
        setShowErrorMessage(`Please enter return quantity in row ${rowIndex}.`);
        return;
      }

      // No decimals
      if (String(row.returnQty).includes('.')) {
        setOpenErrorSnackbar(true);
        handleopenCloseErrorSnackbar(true);
        setShowErrorMessage(
          `Decimals are not allowed in return quantity (row ${rowIndex}).`
        );
        return;
      }

      const num = Number(row.returnQty);

      // Numeric check
      if (Number.isNaN(num)) {
        setOpenErrorSnackbar(true);
        handleopenCloseErrorSnackbar(true);
        setShowErrorMessage(
          `Please enter numeric return quantity in row ${rowIndex}.`
        );
        return;
      }

      // > 0 check
      if (num <= 0) {
        setOpenErrorSnackbar(true);
        handleopenCloseErrorSnackbar(true);
        setShowErrorMessage(
          `Return quantity should be greater than zero (row ${rowIndex}).`
        );
        return;
      }

      // Eligible qty check (if applicable per row)
      // const eligible = row.eligibleReturnQty ?? selectedReturnItem?.eligibleReturnQty ?? 0;
      // if (eligible && num > eligible) {
      //   setOpenErrorSnackbar(true);
      //   handleopenCloseErrorSnackbar(true);
      //   setShowErrorMessage(
      //     `Return quantity cannot exceed eligible quantity (${eligible}) in row ${rowIndex}.`
      //   );
      //   return;
      // }
    }

    // ✅ All validations passed

    const excessParts = rows.map((row) => {
      const returnImages: any = {};

      row.files.forEach((file: any) => {
        const imgKey = `Image_${Object.keys(returnImages).length + 1}`;
        returnImages[imgKey] = [

          {
            id: file.id,
            name: file.name,
            url: file.url,
          },
        ];
      });

      return {
        materialNumber: row.partNo.trim(),
        description: row.description,
        returnQty: row.returnQty.trim(),
        returnImages,
      };
    });
    let userRole: any = sessionStorage.getItem('userType-Profile-API');

    const payload = {
      excessParts,
      invoiceNumber: props.invoiceData?.data?.invoiceNumber,
      createdBy: isFSE ? billingDetails?.data?.data?.data?.customerName : customerName,
      sapCustomerId: isFSE ? billingDetails?.data?.data?.data?.sapCustomerId : sapCustomerId,
      role: userRole
    };

    // ---------- DISPATCH ----------
    if (isUpdateMode) {
      saveReturnRequest(payload)
    } else {
      let responseData: any = await dispatch(createExcessReturnRequest(payload));

      if (responseData && responseData.status === 400) {
        setOpenErrorSnackbar(true);
        handleopenCloseErrorSnackbar(true);
        setShowErrorMessage(responseData && responseData.error);
        setLoading(false);
      } else {
        setOpenErrorSnackbar(false);
        handleopenCloseErrorSnackbar(false);
        setShowErrorMessage(null);
        props.getInvoiceDetails();
        handleopenClose();
        setLoading(false);
      }
    }
  };


  const handleConfirmYes = (responseEtag?: string) => {
    setShowConfirmDialog(false);

    // Call the callback to update parent component with materialNumber and etag
    if (onReturnSuccess && selectedReturnItem) {
      onReturnSuccess(selectedReturnItem.materialNumber, {
        returnQty: Number(returnQty),
        returnReason: selectedReason,
        returnImages: uploadedFiles,
        comment: message
      }, responseEtag);
    }

    // Reset form
    setReturnQty('');
    setSelectedReason('');
    setUploadedFiles({});
    setUploadProgress({});
    setMessage('');

    handleopenClose();
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const isBrowseFileDisabled = selectedReason === "";

  const formatFileSize = (bytes: number) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i)) + ' ' + sizes[i];
  };

  const canUploadImages = Boolean(selectedReason);

  const handlePartSearchSubmit = async (index: number) => {
    const partNumber = rows[index].partNo;

    if (!partNumber || !partNumber.trim()) {
      setOpenErrorSnackbar(true);
      setShowErrorMessage('Part number is required.');
      return;
    }

    const data: any = await dispatch(
      searchProducts(
        customerTierType,
        partNumber,
        enquirySessionId,
        firstName,
        "",
        b2bUserId,
        [{ productId: partNumber, quantity: 1 }]
      )
    );

    if (data && data.error) {
      setShowErrorMessage('Not a valid part. Please enter a valid part number.');
      handleopenCloseErrorSnackbar(true);
      return;
    }

    const product = data?.data?.[0];
    const updated = [...rows];

    const dynamicDescription =
      product?.attributes?.materialDescription?.value ||
      product?.description?.EN ||
      '';

    const latestPartno = product?.productId || updated[index].partNo.toUpperCase();
    // ✅ Update only the searched row
    updated[index].description = dynamicDescription;
    updated[index].partNo = latestPartno;

    setRows(updated);
  };


  return (
    <Fragment>
      {loading && <FullscreenLoader />}
      {billingDetails && billingDetails.loading && <FullscreenLoader />}

      <Snackbar
        open={openSnackbar}
        message={successMessage}
        handleopenClose={() => handleopenCloseSnackbar(false)}
      />
      <Snackbar
        open={openErrorSnackbar}
        type="error"
        message={showErrorMessage}
        handleopenClose={() => handleopenCloseErrorSnackbar(false)}
      />

      {/* Main Return Request Dialog */}
      <Dialog
        open={props.open}
        className='excess'
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={'md'}
        fullWidth
      >
        <div className={classes.root}>
          <Toolbar className={clsx(classes.root)} style={{ minHeight: 56 }}>
            <div className="col-12" style={{ padding: '4px 0' }}>
              <Typography className={classes.title} variant="h4" id="tableTitle" component="div">
                <h4 className="shift-to-party-page-title" style={{ margin: 0 }}>
                  <div className={classes.addUpdateDailogTitle}>
                    Return Excess Part/Quantity
                    {/* <span className={classes.invoiceNumber}>
                                            (Invoice No: {props.invoiceData?.data?.invoiceNumber || '-'})
                                        </span> */}
                  </div>
                  <IconButton disabled aria-label="close" className="float-right" onClick={handleopenClose}>
                    <CloseIcon />
                  </IconButton>
                </h4>
              </Typography>
            </div>
          </Toolbar>
        </div>
        <DialogContent className={classes.dialogContent}>
          <TableContainer>
            <Table className={classes.table} size="small">
              <TableHead>
                {/* FIRST ROW*/}
                <TableRow>
                  <TableCell className={classes.firsRowHeader} width="20%">
                    Part No.
                  </TableCell>
                  <TableCell className={classes.firsRowHeader} width="20%">
                    Description
                  </TableCell>
                  <TableCell className={classes.firsRowHeader} width="15%">
                    Return Quantity
                  </TableCell>
                  <TableCell className={classes.firsRowHeader} width="20%">
                    Upload Images
                  </TableCell>
                  <TableCell className={classes.firsRowHeader} width="20%" />

                  {isUpdateMode ? null : (
                    <TableCell
                      style={{ borderBottom: "none", }}
                      width="5%"
                      align="left"
                      className="p-0 mr-1"
                    >
                      <Tooltip title="Add more" placement="left">
                        <IconButton onClick={handleAddRow}>
                          <AddCircleIcon style={{ color: '#1a9fe0' }} />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  )}
                </TableRow>

                {/* SECOND ROW*/}
                <TableRow >
                  <TableCell className={classes.SecondRowHeader} />
                  <TableCell className={classes.SecondRowHeader} />
                  <TableCell className={classes.SecondRowHeader}>
                    <span style={{ fontSize: "10px" }}>
                      (Enter the excess quantity<br /> to be returned)
                    </span>
                  </TableCell>
                  <TableCell className={classes.SecondRowHeader}>
                    <span style={{ fontSize: "10px" }}>
                      Only JPG, JPEG, PNG files are<br />allowed (Max size: 5 MB).
                    </span>
                  </TableCell>
                  <TableCell className={classes.SecondRowHeader} />
                  <TableCell className={classes.SecondRowHeader} />
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, index) => (
                  <TableRow key={index}>
                    {/* Part No */}
                    <TableCell style={{ verticalAlign: 'top', paddingBottom: 20, paddingTop: 20 }}>
                      <FormControl variant="outlined" disabled={isUpdateMode}>
                        <InputLabel htmlFor="dealer-search" className="rounded-button-dealer-search" margin="dense" style={{ paddingLeft: '4px', paddingRight: '4px', }}>enter the Part No</InputLabel>
                        <OutlinedInput
                          id="dealer-search"
                          value={row.partNo}
                          disabled={isUpdateMode}
                          onKeyPress={(ev: any) => {
                            if (ev.key === 'Enter') {
                              // searchDealerList(searchValue, true);
                              // setPage(0);
                            }
                          }}
                          onChange={(e) => {
                            // Accepts only Alpha-numeric and hyphen.
                            const alphanumericValue =
                              e.target.value.replace(/[^a-zA-Z0-9-]/g, '');
                            handlePartChange(index, alphanumericValue);
                          }}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="Enter the Part No"
                                disabled={isUpdateMode}
                                edge="end"
                                onClick={(e: any) => {
                                  handlePartSearchSubmit(index)
                                }}
                              >
                                <SearchIcon />
                              </IconButton>
                            </InputAdornment>
                          }
                          labelWidth={120} label="Enter the Part No" margin="dense" className="rounded-button-dealer-search mr-2 w-190" />
                      </FormControl>
                    </TableCell>
                    {/* Description */}
                    <TableCell style={{ verticalAlign: 'top', paddingBottom: 20, paddingTop: 20 }}>
                      {row.description !== '' ? <div className="text-center text-666">{row.description}</div>
                        : (
                          <TextField
                            value={row.description}
                            placeholder="Description"
                            disabled
                            fullWidth
                            className={classes.inputField}
                            variant="outlined"
                            size="small"
                          />
                        )}
                    </TableCell>

                    {/* Return Qty */}
                    <TableCell style={{ verticalAlign: 'top', paddingBottom: 20, paddingTop: 20 }}>
                      <TextField
                        placeholder="Excess qty"
                        value={row.returnQty}
                        type="text"
                        inputProps={{
                          inputMode: 'numeric',
                          pattern: '[0-9]*',
                          maxLength: 5
                        }}
                        onChange={(e) => {
                          // Accepts only numeric values.
                          const numericValue = e.target.value.replace(/[^0-9]/g, '');
                          handleQtyChange(index, numericValue);
                        }}

                        className={classes.inputField}
                        fullWidth
                        variant="outlined"
                        size="small"
                      />
                    </TableCell>

                    {/* Upload */}
                    <TableCell style={{ verticalAlign: 'top', textAlign: 'center' }}>
                      <Button
                        variant="contained"
                        component="span"
                        color="secondary"
                        className="rounded-button-dealer pl-4 pr-4 mt-3"
                        onClick={() => handleBrowseFile(`RETURN_IMAGE_${index}`)}
                      >
                        Browse File
                      </Button>
                    </TableCell>
                    {/* File names */}
                    <TableCell>
                      {(row.files || []).map((file, i) => (
                        <div style={{ display: 'flex', alignItems: 'center' }} key={i}>
                          <span style={{ flex: 1, fontSize: 12 }}>
                            {file.name}
                          </span>

                          <IconButton
                            size="small"
                            onClick={() => handleRemoveFile(`RETURN_IMAGE_${index}`, i)}
                          >
                            <CancelIcon style={{ fontSize: 18, color: '#1a9fe0' }} />

                          </IconButton>
                        </div>
                      ))}
                    </TableCell>
                    <TableCell align="center" className='p-0'>
                      {rows.length > 1 && (
                        <IconButton onClick={() => handleDeleteRow(index)}>
                          <DeleteIcon color="secondary" />
                        </IconButton>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>

        <DialogActions className={classes.dialogActions}>
          <Button
            variant="contained"
            className={classes.proceedButton}
            onClick={handleProceed}
          // disabled={(!mandatoryUploadsComplete && canUploadImages) || (selectedReason === "06 - Customer Cancelled" && !message.trim())}
          >
            Proceed
          </Button>
          <Button
            variant="contained"
            className={classes.closeButton}
            onClick={handleopenClose}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      {/* Delete Confirmation Dialog */}
      <Dialog
        open={showDeleteConfirmDialog}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
          setShowDeleteConfirmDialog(false);
        }}
        TransitionProps={{
          onExited: () => setIsBulkDelete(false)
        }}
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        fullWidth
      >
        <DialogContent>
          <div className={classes.icon}>
            <WarningIcon className="delete-warning" fontSize="small" />
          </div>
          <DialogContentText id="alert-dialog-description" component="div">
            <div className={`mt-3 ${classes.cancelText}`}>
              {isBulkDelete
                ? 'Do you wish to leave without uploading your details?'
                : 'Do you want to delete this document?'}
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className={`mx-4 ${classes.yes}`} onClick={() => { setShowDeleteConfirmDialog(false); deleteDocument(); }} autoFocus>
            Yes
          </Button>
          <Button
            className={`mr-4 ${classes.cancel}`}
            onClick={() => {
              setShowDeleteConfirmDialog(false);
              setFieldToDelete('');
              setFilesToDelete({});
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/* Confirmation Dialog */}
      <Dialog
        open={showConfirmDialog}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
          setShowConfirmDialog(false);
        }}
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        fullWidth
      >
        <DialogContent>
          <div className={classes.icon}>
            <WarningIcon className="delete-warning" fontSize="small" />
          </div>
          <DialogContentText id="alert-dialog-description" component="div">
            <div className={`mt-3 ${classes.cancelText}`}>
              Do you want to return this item ?
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className={`mx-4 ${classes.yes}`} onClick={
            saveReturnRequest
          }
            autoFocus>
            Yes
          </Button>
          <Button className={`mr-4 ${classes.cancel}`} onClick={() => setShowConfirmDialog(false)}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}